import { KeyValueTranslated } from '../../models/translation';

export const EMPLOYED = 'Employed';
export const SELF_EMPLOYED = 'Self-employed';
export const STUDENT = 'Student';
export const RETIRED = 'Retired';
export const UNEMPLOYED = 'Unemployed';

export const INDUSTRY_ACCOUNTANTS_AND_TRUSTEES = 'Accountants and trustees';
export const INDUSTRY_AGRICULTURAL = 'Agricultural';
export const INDUSTRY_CATERING_HOSPITALITY = 'Catering or hospitality';
export const INDUSTRY_CHARITY = 'Charity';
export const INDUSTRY_COMPANY_SERVICES = 'Company Services';
export const INDUSTRY_DEFENCE_MILITARY = 'Defence, military, arms / weapons trade';
export const INDUSTRY_EDUCATION = 'Education';
export const INDUSTRY_EMERGENCY_SERVICES = 'Emergency Services';
export const INDUSTRY_ENERGY = 'Energy';
export const INDUSTRY_ENGINEERING = 'Engineering';
export const INDUSTRY_EXPORT_IMPORT = 'Export or import';
export const INDUSTRY_FINANCIAL_SERVICES_BANK_INSURANCE = 'Financial Services – Banks/Insurance';
export const INDUSTRY_FINANCIAL_SERVICES_INVESTMENT_PRODUCTS = 'Financial Services - Investment Products';
export const INDUSTRY_GAMBLING_CASINO = 'Gambling/Casino';
export const INDUSTRY_GOVERNMENT_OR_PUBLIC_SECTOR = 'Government or public sector';
export const INDUSTRY_LEGAL = 'Legal';
export const INDUSTRY_LEISURE_TOURISM = 'Leisure, entertainment, or tourism';
export const INDUSTRY_MANUFACTURING = 'Manufacturing';
export const INDUSTRY_MEDIA_MARKETING_ADVERTISING = 'Media / Marketing / Advertising';
export const INDUSTRY_MONEY_REMITTANCE_MONEYLENDING = 'Money Remittance / Moneylending  / Pawnbrokers / New Payment Providers';
export const INDUSTRY_NGO_NPO = 'Non-Governmental Organisation (NGO) / Non-Profit Organisation (NPO)';
export const INDUSTRY_OTHER = 'Other';
export const INDUSTRY_PRECIOUS_METALS_STONES = 'Precious Metals or stones';
export const INDUSTRY_PROPERTY_CONSTRUCTION_TRADE = 'Property, construction, or trade';
export const INDUSTRY_RETAIL = 'Retail';
export const INDUSTRY_RETAIL_AUCTION = 'Retail - Auction';
export const INDUSTRY_RETAIL_HIGH_VALUE_GOODS = 'Retail - High-value goods';
export const INDUSTRY_RETAIL_WHOLESALE = 'Retail - Wholesale';
export const INDUSTRY_SOCIAL_CARE_SERVICES_HEALTH_MEDICINE = 'Social care, services, health, or medicine';
export const INDUSTRY_SPORTS = 'Sports';
export const INDUSTRY_TECHNOLOGY = 'Technology';
export const INDUSTRY_TELECOMMUNICATIONS = 'Telecommunications';
export const INDUSTRY_TRANSPORT_LOGISTICS = 'Transport / Logistics';

const INDUSTRY_DEFAULT_OCCUPATION_LIST: KeyValueTranslated = {
  'Company Owner/Director/Management': (t) => t('Company Owner/Director/Management'),
  Manager: (t) => t('Manager'),
  'General staff member': (t) => t('General staff member'),
  Other: (t) => t('Other')
};

const INDUSTRY_TRANSPORT_LOGISTICS_OCCUPATION_LIST: KeyValueTranslated = {
  'Company Owner/Director/Management': (t) => t('Company Owner/Director/Management'),
  'General staff member': (t) => t('General staff member'),
  Other: (t) => t('Other')
};

const INDUSTRY_MONEY_REMITTANCE_MONEYLENDING_OCCUPATION_LIST: KeyValueTranslated = {
  'Company Owner/Director/Management': (t) => t('Company Owner/Director/Management'),
  Partner: (t) => t('Partner'),
  'General staff member': (t) => t('General staff member'),
  Other: (t) => t('Other')
};

const INDUSTRY_MANUFACTURING_OCCUPATION_LIST: KeyValueTranslated = {
  'Company Owner/Director/Management': (t) => t('Company Owner/Director/Management'),
  'General staff member': (t) => t('General staff member'),
  Other: (t) => t('Other')
};

const INDUSTRY_CHARITY_OCCUPATION_LIST: KeyValueTranslated = {
  'Company Owner/Director/Management': (t) => t('Company Owner/Director/Management'),
  Partner: (t) => t('Partner'),
  'General staff member': (t) => t('General staff member'),
  Other: (t) => t('Other')
};

const INDUSTRY_FINANCIAL_SERVICES_BANK_INSURANCE_OCCUPATION_LIST: KeyValueTranslated = {
  'Company Owner/Director': (t) => t('Company Owner/Director'),
  Management: (t) => t('Management'),
  Manager: (t) => t('Manager'),
  Analyst: (t) => t('Analyst'),
  Other: (t) => t('Other')
};

const INDUSTRY_FINANCIAL_SERVICES_INVESTMENT_PRODUCTS_OCCUPATION_LIST: KeyValueTranslated = {
  'Company Owner/Director/Management': (t) => t('Company Owner/Director/Management'),
  Manager: (t) => t('Manager'),
  Analyst: (t) => t('Analyst'),
  Other: (t) => t('Other')
};

const INDUSTRY_RETAIL_OCCUPATION_LIST: KeyValueTranslated = {
  'Company Owner/Director/Management': (t) => t('Company Owner/Director/Management'),
  'General staff member': (t) => t('General staff member'),
  Other: (t) => t('Other')
};

const INDUSTRY_AGRICULTURAL_OCCUPATION_LIST: KeyValueTranslated = {
  Agronomist: (t) => t('Agronomist'),
  'Animal nutritionist': (t) => t('Animal nutritionist'),
  Ecologist: (t) => t('Ecologist'),
  Engineer: (t) => t('Engineer'),
  Horticulturist: (t) => t('Horticulturist'),
  Other: (t) => t('Other'),
  Scientist: (t) => t('Scientist'),
  Technician: (t) => t('Technician'),
  Worker: (t) => t('Worker')
};

const INDUSTRY_COMPANY_SERVICES_OCCUPATION_LIST: KeyValueTranslated = {
  'Company Owner/Director/Management': (t) => t('Company Owner/Director/Management'),
  Manager: (t) => t('Manager'),
  Analyst: (t) => t('Analyst'),
  Other: (t) => t('Other')
};

const INDUSTRY_DEFENCE_MILITARY_OCCUPATION_LIST: KeyValueTranslated = {
  'Company Owner/Director/Management': (t) => t('Company Owner/Director/Management'),
  Partner: (t) => t('Partner'),
  'Ranks equivalent to Officer and above': (t) => t('Ranks equivalent to Officer and above'),
  'Ranks below Officer level': (t) => t('Ranks below Officer level'),
  Clerical: (t) => t('Clerical'),
  Other: (t) => t('Other')
};

const INDUSTRY_EDUCATION_OCCUPATION_LIST: KeyValueTranslated = {
  Administrator: (t) => t('Administrator'),
  'General staff member': (t) => t('General staff member'),
  Other: (t) => t('Other'),
  'Teacher / Principal': (t) => t('Teacher / Principal')
};

const INDUSTRY_EMERGENCY_SERVICES_OCCUPATION_LIST: KeyValueTranslated = {
  Firefighter: (t) => t('Firefighter'),
  Medic: (t) => t('Medic'),
  Other: (t) => t('Other'),
  Paramedic: (t) => t('Paramedic'),
  'Security Officer': (t) => t('Security Officer'),
  Technician: (t) => t('Technician ')
};

const INDUSTRY_ENERGY_OCCUPATION_LIST: KeyValueTranslated = {
  'Company Owner/Director/Management': (t) => t('Company Owner/Director/Management'),
  Manager: (t) => t('Manager'),
  Analyst: (t) => t('Analyst'),
  Other: (t) => t('Other')
};

const INDUSTRY_GAMBLING_CASINO_OCCUPATION_LIST: KeyValueTranslated = {
  'Company Owner/Director/Management': (t) => t('Company Owner/Director/Management'),
  Manager: (t) => t('Manager'),
  Analyst: (t) => t('Analyst'),
  Other: (t) => t('Other')
};

const INDUSTRY_GOVERNMENT_OR_PUBLIC_SECTOR_OCCUPATION_LIST: KeyValueTranslated = {
  'Ambassador or consul': (t) => t('Ambassador or consul'),
  'Board member/Director of Enterprise State-Owned': (t) => t('Board member/Director of Enterprise State-Owned'),
  'Chief Executive in State-Owned Enterprise': (t) => t('Chief Executive in State-Owned Enterprise'),
  'Director in State-Owned Enterprise': (t) => t('Director in State-Owned Enterprise'),
  'Director/Deputy Director/Board Members/Equivalent function of an international organisation': (t) =>
    t('Director/Deputy Director/Board Members/Equivalent function of an international organisation'),
  'Member of city council': (t) => t('Member of city council'),
  'Member of parliament': (t) => t('Member of parliament'),
  'Member of the Supreme court': (t) => t('Member of the Supreme court'),
  Other: (t) => t('Other'),
  'Senior Civil Servant with Procurement /Contracts Management Responsibilities': (t) =>
    t('Senior Civil Servant with Procurement /Contracts Management Responsibilities'),
  'Senior Member of Armed Forces': (t) => t('Senior Member of Armed Forces'),
  'Voivode/Governor /Director/Manager of the main/central/voivodeship/local special administration body': (t) =>
    t('Voivode/Governor /Director/Manager of the main/central/voivodeship/local special administration body')
};

const INDUSTRY_LEGAL_OCCUPATION_LIST: KeyValueTranslated = {
  'Company Owner/Director/Management': (t) => t('Company Owner/Director/Management'),
  Lawyer: (t) => t('Lawyer'),
  Partner: (t) => t('Partner'),
  Paralegal: (t) => t('Paralegal'),
  'General staff member': (t) => t('General staff member')
};

const INDUSTRY_LEISURE_TOURISM_OCCUPATION_LIST: KeyValueTranslated = {
  'Company Owner/Director/Management': (t) => t('Company Owner/Director/Management'),
  'General staff member': (t) => t('General staff member'),
  Other: (t) => t('Other')
};

const INDUSTRY_MEDIA_MARKETING_ADVERTISING_OCCUPATION_LIST: KeyValueTranslated = {
  'Company Owner/Director/Management': (t) => t('Company Owner/Director/Management'),
  'General staff member': (t) => t('General staff member'),
  Other: (t) => t('Other')
};

const INDUSTRY_NGO_NPO_OCCUPATION_LIST: KeyValueTranslated = {
  'Director or board member': (t) => t('Director or board member'),
  Other: (t) => t('Other')
};

const INDUSTRY_OTHER_OCCUPATION_LIST: KeyValueTranslated = {
  Other: (t) => t('Other')
};

const INDUSTRY_PRECIOUS_METALS_STONES_OCCUPATION_LIST: KeyValueTranslated = {
  'Company Owner/Director/Management': (t) => t('Company Owner/Director/Management'),
  Goldsmith: (t) => t('Goldsmith'),
  Manager: (t) => t('Manager'),
  Analyst: (t) => t('Analyst'),
  Other: (t) => t('Other')
};

const INDUSTRY_PROPERTY_CONSTRUCTION_TRADE_OCCUPATION_LIST: KeyValueTranslated = {
  'Company Owner/Director/Management': (t) => t('Company Owner/Director/Management'),
  'Real Estate Agent': (t) => t('Real Estate Agent'),
  'General staff member': (t) => t('General staff member'),
  Other: (t) => t('Other')
};

const INDUSTRY_SOCIAL_CARE_SERVICES_HEALTH_MEDICINE_OCCUPATION_LIST: KeyValueTranslated = {
  'Company Owner/Director/Management': (t) => t('Company Owner/Director/Management'),
  'General staff member': (t) => t('General staff member'),
  Other: (t) => t('Other')
};

const INDUSTRY_SPORTS_OCCUPATION_LIST: KeyValueTranslated = {
  'Agent or representative': (t) => t('Agent or representative'),
  Other: (t) => t('Other')
};

const INDUSTRY_TECHNOLOGY_OCCUPATION_LIST: KeyValueTranslated = {
  'Company Owner/Director/Management': (t) => t('Company Owner/Director/Management'),
  'General staff member': (t) => t('General staff member'),
  Other: (t) => t('Other')
};

const INDUSTRY_TELECOMMUNICATIONS_OCCUPATION_LIST: KeyValueTranslated = {
  'Company Owner/Director/Management': (t) => t('Company Owner/Director/Management'),
  'General staff member': (t) => t('General staff member'),
  Other: (t) => t('Other')
};

const INDUSTRY_ACCOUNTANTS_AND_TRUSTEES_OCCUPATION_LIST: KeyValueTranslated = {
  'Company Owner/Director/Management': (t) => t('Company Owner/Director/Management'),
  'Sole accountant / Partner': (t) => t('Sole accountant / Partner'),
  'Auditor / Accountant': (t) => t('Auditor / Accountant'),
  Other: (t) => t('Other')
};

export const SOURCE_OF_FUNDS_PART_TIME_WORK = 'Part-time work';

export const OTHER = 'Other';

export const EMPLOY_STATUS: KeyValueTranslated = {
  [EMPLOYED]: (t) => t('Employed'),
  [SELF_EMPLOYED]: (t) => t('Self-employed')
};

export const EMPLOYMENT_STATUS: KeyValueTranslated = {
  ...EMPLOY_STATUS,
  [STUDENT]: (t) => t('Student'),
  [RETIRED]: (t) => t('Retired'),
  [UNEMPLOYED]: (t) => t('Unemployed')
};

export const INDUSTRY_NAME: KeyValueTranslated = {
  [INDUSTRY_ACCOUNTANTS_AND_TRUSTEES]: (t) => t('Accountants and trustees'),
  [INDUSTRY_AGRICULTURAL]: (t) => t('Agricultural'),
  [INDUSTRY_CATERING_HOSPITALITY]: (t) => t('Catering or hospitality'),
  [INDUSTRY_CHARITY]: (t) => t('Charity'),
  [INDUSTRY_COMPANY_SERVICES]: (t) => t('Company Services'),
  [INDUSTRY_DEFENCE_MILITARY]: (t) => t('Defence, military, arms / weapons trade'),
  [INDUSTRY_EDUCATION]: (t) => t('Education'),
  [INDUSTRY_EMERGENCY_SERVICES]: (t) => t('Emergency Services'),
  [INDUSTRY_ENERGY]: (t) => t('Energy'),
  [INDUSTRY_ENGINEERING]: (t) => t('Engineering'),
  [INDUSTRY_EXPORT_IMPORT]: (t) => t('Export or import'),
  [INDUSTRY_FINANCIAL_SERVICES_BANK_INSURANCE]: (t) => t('Financial Services – Banks/Insurance'),
  [INDUSTRY_FINANCIAL_SERVICES_INVESTMENT_PRODUCTS]: (t) => t('Financial Services - Investment Products'),
  [INDUSTRY_GAMBLING_CASINO]: (t) => t('Gambling/Casino'),
  [INDUSTRY_GOVERNMENT_OR_PUBLIC_SECTOR]: (t) => t('Government or public sector'),
  [INDUSTRY_LEGAL]: (t) => t('Legal'),
  [INDUSTRY_LEISURE_TOURISM]: (t) => t('Leisure, entertainment, or tourism'),
  [INDUSTRY_MANUFACTURING]: (t) => t('Manufacturing'),
  [INDUSTRY_MEDIA_MARKETING_ADVERTISING]: (t) => t('Media / Marketing / Advertising'),
  [INDUSTRY_MONEY_REMITTANCE_MONEYLENDING]: (t) => t('Money Remittance / Moneylending  / Pawnbrokers / New Payment Providers'),
  [INDUSTRY_NGO_NPO]: (t) => t('Non-Governmental Organisation (NGO) / Non-Profit Organisation (NPO)'),
  [INDUSTRY_OTHER]: (t) => t('Other'),
  [INDUSTRY_PRECIOUS_METALS_STONES]: (t) => t('Precious Metals or stones'),
  [INDUSTRY_PROPERTY_CONSTRUCTION_TRADE]: (t) => t('Property, construction, or trade'),
  [INDUSTRY_RETAIL]: (t) => t('Retail'),
  [INDUSTRY_SOCIAL_CARE_SERVICES_HEALTH_MEDICINE]: (t) => t('Social care, services, health, or medicine'),
  [INDUSTRY_SPORTS]: (t) => t('Sports'),
  [INDUSTRY_TECHNOLOGY]: (t) => t('Technology'),
  [INDUSTRY_TELECOMMUNICATIONS]: (t) => t('Telecommunications'),
  [INDUSTRY_TRANSPORT_LOGISTICS]: (t) => t('Transport / Logistics')
};

export const OCCUPATION: Record<string, KeyValueTranslated> = {
  [INDUSTRY_ACCOUNTANTS_AND_TRUSTEES]: INDUSTRY_ACCOUNTANTS_AND_TRUSTEES_OCCUPATION_LIST,
  [INDUSTRY_AGRICULTURAL]: INDUSTRY_AGRICULTURAL_OCCUPATION_LIST,
  [INDUSTRY_CATERING_HOSPITALITY]: INDUSTRY_DEFAULT_OCCUPATION_LIST,
  [INDUSTRY_CHARITY]: INDUSTRY_CHARITY_OCCUPATION_LIST,
  [INDUSTRY_COMPANY_SERVICES]: INDUSTRY_COMPANY_SERVICES_OCCUPATION_LIST,
  [INDUSTRY_DEFENCE_MILITARY]: INDUSTRY_DEFENCE_MILITARY_OCCUPATION_LIST,
  [INDUSTRY_EDUCATION]: INDUSTRY_EDUCATION_OCCUPATION_LIST,
  [INDUSTRY_EMERGENCY_SERVICES]: INDUSTRY_EMERGENCY_SERVICES_OCCUPATION_LIST,
  [INDUSTRY_ENERGY]: INDUSTRY_ENERGY_OCCUPATION_LIST,
  [INDUSTRY_ENGINEERING]: INDUSTRY_DEFAULT_OCCUPATION_LIST,
  [INDUSTRY_EXPORT_IMPORT]: INDUSTRY_DEFAULT_OCCUPATION_LIST,
  [INDUSTRY_FINANCIAL_SERVICES_BANK_INSURANCE]: INDUSTRY_FINANCIAL_SERVICES_BANK_INSURANCE_OCCUPATION_LIST,
  [INDUSTRY_FINANCIAL_SERVICES_INVESTMENT_PRODUCTS]: INDUSTRY_FINANCIAL_SERVICES_INVESTMENT_PRODUCTS_OCCUPATION_LIST,
  [INDUSTRY_GAMBLING_CASINO]: INDUSTRY_GAMBLING_CASINO_OCCUPATION_LIST,
  [INDUSTRY_GOVERNMENT_OR_PUBLIC_SECTOR]: INDUSTRY_GOVERNMENT_OR_PUBLIC_SECTOR_OCCUPATION_LIST,
  [INDUSTRY_LEGAL]: INDUSTRY_LEGAL_OCCUPATION_LIST,
  [INDUSTRY_LEISURE_TOURISM]: INDUSTRY_LEISURE_TOURISM_OCCUPATION_LIST,
  [INDUSTRY_MANUFACTURING]: INDUSTRY_MANUFACTURING_OCCUPATION_LIST,
  [INDUSTRY_MEDIA_MARKETING_ADVERTISING]: INDUSTRY_MEDIA_MARKETING_ADVERTISING_OCCUPATION_LIST,
  [INDUSTRY_MONEY_REMITTANCE_MONEYLENDING]: INDUSTRY_MONEY_REMITTANCE_MONEYLENDING_OCCUPATION_LIST,
  [INDUSTRY_NGO_NPO]: INDUSTRY_NGO_NPO_OCCUPATION_LIST,
  [INDUSTRY_OTHER]: INDUSTRY_OTHER_OCCUPATION_LIST,
  [INDUSTRY_PRECIOUS_METALS_STONES]: INDUSTRY_PRECIOUS_METALS_STONES_OCCUPATION_LIST,
  [INDUSTRY_PROPERTY_CONSTRUCTION_TRADE]: INDUSTRY_PROPERTY_CONSTRUCTION_TRADE_OCCUPATION_LIST,
  [INDUSTRY_RETAIL]: INDUSTRY_RETAIL_OCCUPATION_LIST,
  [INDUSTRY_SOCIAL_CARE_SERVICES_HEALTH_MEDICINE]: INDUSTRY_SOCIAL_CARE_SERVICES_HEALTH_MEDICINE_OCCUPATION_LIST,
  [INDUSTRY_SPORTS]: INDUSTRY_SPORTS_OCCUPATION_LIST,
  [INDUSTRY_TECHNOLOGY]: INDUSTRY_TECHNOLOGY_OCCUPATION_LIST,
  [INDUSTRY_TELECOMMUNICATIONS]: INDUSTRY_TELECOMMUNICATIONS_OCCUPATION_LIST,
  [INDUSTRY_TRANSPORT_LOGISTICS]: INDUSTRY_TRANSPORT_LOGISTICS_OCCUPATION_LIST
};

export const SOURCE_OF_FUNDS_BASE: KeyValueTranslated = {
  'Savings / Investments': (t) => t('Savings / Investments'),
  'Benefits or borrowing': (t) => t('Benefits or borrowing'),
  Pension: (t) => t('Pension'),
  'Property income': (t) => t('Property income'),
  [OTHER]: (t) => t('Other')
};

export const SOURCE_OF_FUNDS: Record<string, KeyValueTranslated> = {
  [STUDENT]: {
    [SOURCE_OF_FUNDS_PART_TIME_WORK]: (t) => t('Part-time work'),
    ...SOURCE_OF_FUNDS_BASE
  },
  [RETIRED]: {
    [SOURCE_OF_FUNDS_PART_TIME_WORK]: (t) => t('Part-time work'),
    ...SOURCE_OF_FUNDS_BASE
  },
  [UNEMPLOYED]: {
    'Family or partner support': (t) => t('Family or partner support'),
    ...SOURCE_OF_FUNDS_BASE
  }
};
